import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getAddressSuggestions } from '@/infra/services'

export const useGetAddressSuggestions = (query: string) =>
  useQuery({
    queryKey: ['addressSuggestions', query],
    queryFn: () => getAddressSuggestions(query),
    enabled: query.trim().length >= 3,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false
  })
